"use client";

import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface PageLoaderProps {
  /** Optional message to show below the spinner */
  message?: string;
  /** Size variant */
  size?: "sm" | "md" | "lg";
  /** Additional class names */
  className?: string;
  /** Whether to take full viewport height (default: false, uses h-64) */
  fullHeight?: boolean;
}

const sizeClasses = {
  sm: "w-6 h-6",
  md: "w-8 h-8",
  lg: "w-12 h-12",
};

export function PageLoader({
  message,
  size = "md",
  className,
  fullHeight = false,
}: PageLoaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center",
        fullHeight ? "min-h-[50vh]" : "h-64",
        className
      )}
    >
      <div className="relative">
        {/* Outer ring */}
        <div
          className={cn(
            "absolute inset-0 rounded-full border-2 border-muted-foreground/20",
            sizeClasses[size]
          )}
        />
        {/* Spinning loader */}
        <Loader2
          className={cn(
            "animate-spin text-primary",
            sizeClasses[size]
          )}
        />
      </div>
      {message && (
        <p className="mt-4 text-sm text-muted-foreground animate-pulse">
          {message}
        </p>
      )}
    </div>
  );
}
